import { useCallback } from "react";

import Analytics, { Mode, initBlizzard } from "@snapchat/blizzard";
import { type AppBuild } from "@snapchat/blizzard/lib/environment";

import { isPreProd, isProd, isProdLike } from "../../shared/constants";

const TWO_HOURS_SCA_EXPIRE_TIME = 1 / 12;

const getBlizzardAppBuild = (): AppBuild => {
    if (isProd()) {
        return "PROD";
    }
    if (isPreProd()) {
        return "BETA";
    }
    return "DEBUG";
};

export const useInitializeBlizzard = (): ((onInit: () => void, userGuid?: Promise<string>) => void) => {
    return useCallback((onInit: () => void, userGuid?: Promise<string>) => {
        Analytics.setCookieDomain("snapchat.com");
        Analytics.setCookieExpireTime(TWO_HOURS_SCA_EXPIRE_TIME);
        Analytics.setCookiesEnabled(true);

        initBlizzard({
            appEnvironment: {
                appType: "WEB_DESKTOP",
                appBuild: getBlizzardAppBuild(),
            },
            mode: isProd() ? Mode.PROD : Mode.STAGE,

            debugLoggingEnabled: !isProdLike(),

            userGuid,
        });

        onInit();
    }, []);
};
